import React from 'react';
import { TypewriterText } from '@/components/custom/typewriter-text';
import { cn } from '@/lib/utils';

function TiaBanner({ image, imageAlt = 'T.I.A', imageHeight = 180, imageOffset = 170, imageClassName, bubbleMaxWidth = 800, bubbleCorner = 'bl', bubbleIcon, text, decoration, className }) {
  return (
    <div
      className={cn('relative flex items-center gap-3 rounded-[24px] p-4 pl-[var(--tia-offset)] shadow-card', className)}
      style={{
        background: 'var(--color-bg-lilac)',
        '--tia-offset': `${imageOffset}px`,
        '--tia-height': `${imageHeight}px`
      }}
    >
      {decoration}

      <img
        src={image}
        alt={imageAlt}
        className={cn('pointer-events-none absolute bottom-0 left-2 z-10 h-[var(--tia-height)] w-auto object-contain object-bottom', imageClassName)}
      />

      <div
        className={cn('relative z-10 flex flex-1 items-start gap-3 rounded-[16px] bg-white p-5 shadow-card', bubbleCorner === 'bl' ? 'rounded-bl-none' : 'rounded-tl-none')}
        style={{ maxWidth: bubbleMaxWidth }}
      >
        <div>
          <p
            className="mb-0 whitespace-pre-line text-sm font-bold leading-relaxed"
            style={{ color: '#222731' }}
          >
            <TypewriterText text={text} />
          </p>
        </div>

        {bubbleIcon && (
          <img
            src={bubbleIcon}
            alt=""
            className="h-auto w-4 shrink-0"
          />
        )}
      </div>
    </div>
  );
}

export { TiaBanner };
